import { environment } from '../../../environments/environment';

/** The API's origin and its own path prefix (`/api`), from `environment.apiUrl`. */
const API_URL = new URL(environment.apiUrl, window.location.origin);
const API_PREFIX = `${API_URL.pathname.replace(/\/+$/, '')}/`;

/**
 * A route the backend hands out (`/api/intelligence/…`, or the same URL made
 * absolute) as the path `HttpClient` takes here (`intelligence/…`): the API
 * interceptor puts the base URL and the token back. An absolute URL would go
 * out without the token (the interceptor treats it as external). `null` when
 * the URL is not a route of this API.
 */
export function apiRoute(url: string | null | undefined): string | null {
  if (!url) return null;
  let parsed: URL;
  try {
    parsed = new URL(url, API_URL.origin);
  } catch {
    return null;
  }
  if (parsed.origin !== API_URL.origin) return null;
  const path = parsed.pathname + parsed.search;
  return path.startsWith(API_PREFIX) ? path.slice(API_PREFIX.length) : null;
}
